import { keysToSnakeCase } from './keysToSnakeCase'

export const serialize = (params: Record<string, any>) => {
  const keys = keysToSnakeCase(params)
  const searchParams = new URLSearchParams()

  const flattenObject = (
    obj: Record<string, any>,
    parentKey = '',
    result: Record<string, any> = {},
    isArray = false,
  ) => {
    for (const key in obj) {
      if (obj[key] !== undefined) {
        const newKey = parentKey ? `${parentKey}[${isArray ? '' : key}]` : key

        if (typeof obj[key] === 'object') {
          flattenObject(obj[key], newKey, result, Array.isArray(obj[key]))
        } else {
          searchParams.append(newKey, obj[key])
        }
      }
    }

    return result
  }

  flattenObject(keys)

  return searchParams.toString()
}
